import { createSlice } from '@reduxjs/toolkit'
import { IAbout } from 'models/About/IAbout'

export interface AboutState {
  isLoading: boolean
  isGetAboutSuccess: boolean
  aboutData: IAbout[] | null
  homeAbout: IAbout[] | null
  whoWeAre: IAbout[] | null
  principles: IAbout[] | null
  values: IAbout[] | null
  goals: IAbout[] | null
  quotations: IAbout[] | null
}

const initialState: AboutState = {
  isLoading: false,
  isGetAboutSuccess: false,
  aboutData: null,
  homeAbout: null,
  whoWeAre: null,
  principles: null,
  values: null,
  goals: null,
  quotations: null,
}

const aboutSlice = createSlice({
  name: 'about',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
    },
    apiFailure: (state) => {
      state.isLoading = false
    },
    getAbout(state, action) {
      state.isLoading = false
      state.isGetAboutSuccess = true
      state.aboutData = action.payload.aboutData.result

      state.homeAbout = action.payload.aboutData.result.filter(
        (item: IAbout) => item.type.toLowerCase() === 'home about'
      )

      state.whoWeAre = action.payload.aboutData.result.filter(
        (item: IAbout) => item.type.toLowerCase() === 'about - man nahnou'
      )

      state.principles = action.payload.aboutData.result.filter(
        (item: IAbout) =>
          item.type.toLowerCase() === 'our principles - mabadi2ouna'
      )

      state.values = action.payload.aboutData.result.filter(
        (item: IAbout) => item.type.toLowerCase() === 'our values - qiyamona'
      )

      state.goals = action.payload.aboutData.result.filter(
        (item: IAbout) => item.type.toLowerCase() === 'our goals - ahdafouna'
      )

      state.quotations = action.payload.aboutData.result.filter(
        (item: IAbout) => item.type.toLowerCase() === 'quotation - iktibas'
      )
    },
  },
})

export const { apiRequest, apiFailure, getAbout } = aboutSlice.actions

export default aboutSlice.reducer
